import CloseIcon from '@mui/icons-material/Close'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import { Avatar, Button, DialogContent, DialogTitle, IconButton } from '@mui/material'
import { useMemo, useState, useEffect } from 'react'
import {
  getLabelForAlreadyPatientOption,
  loadOptionsForExistingPatient,
  PatientSearchCustomOption,
  PatientSearchPlaceholder,
} from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingComponents'
import PastPatientReportsDialog from 'src/clinic/components/ClinicManageBookingsPage/pastPatientReports/PastPatientReportsDialog'
import BaseUITabsComponent from 'src/common/tabs/BaseUITabs'
import { CustomAsyncPaginate } from 'src/consumer/components/helperComponents/dynamic'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import { MUIThemeConfig } from 'src/context/MUIThemeConfig'
import CreateBookingTab from 'src/mentor/components/MentorClinicBookingsPage/component/newBooking/createBooking/CreateBookingTab'
import {
  MENTOR_NEW_BOOKING_TABS,
  MENTOR_NEW_BOOKING_TABS_LIST,
} from 'src/mentor/components/MentorClinicBookingsPage/component/newBooking/newBookingConsts'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import NewPatientForm from '../newPatient/NewPatientForm'
import { PatientsSelectHeaderContainer } from '../styledComponents'

export function NewBookingPopupWithPatientSelection({
  refreshData,
  mentorsList,
  clinicId,
  clinicBrandId,
  searchPatientApiSignature,
  appointmentTypesList,
  mentorProfileData,
  selectedSlotData,
  closeDialog,
  oldBookingDialogComponentRenderer,
  createPatientApiSignature,
  initialSelectedPatient = null,
}) {
  const [selectedPatient, setSelectedPatient] = useState(initialSelectedPatient)
  
  // Update selectedPatient when initialSelectedPatient changes
  useEffect(() => {
    if (initialSelectedPatient) {
      setSelectedPatient(initialSelectedPatient)
    }
  }, [initialSelectedPatient])
  const [showNewPatientForm, setShowNewPatientForm] = useState(false)
  return (
    <NewBookingPopup
      selectedPatient={selectedPatient}
      refreshData={refreshData}
      mentorsList={mentorsList}
      mentorProfileData={mentorProfileData}
      appointmentTypesList={appointmentTypesList}
      defaultTab={MENTOR_NEW_BOOKING_TABS?.appointment?.id}
      selectedSlotData={selectedSlotData}
      closeDialog={closeDialog}
      oldBookingDialogComponentRenderer={oldBookingDialogComponentRenderer}
    >
      <div className="d-flex flex-column gap-2 p-1">
        {!showNewPatientForm ? (
          <div className="d-flex align-items-center gap-1" style={{ fontSize: '16px' }}>
            <PatientsSelectHeaderContainer showAlways style={{ width: '100%' }}>
              {/* <CustomAsyncPaginate
                value={selectedPatient}
                isClearable={true}
                placeholder="Search Patient..."
                loadOptions={loadOptionsForExistingPatient}
                components={{
                  //   NoOptionsMessage: customNoOptionsMessageComponentFunction(
                  //     autoFillStuffForNewPatientString,
                  //     handleAddNewButtonClick,
                  //   ),
                  Placeholder: PatientSearchPlaceholder,
                  Option: PatientSearchCustomOption,
                  //   ClearIndicator: customResetClearFuncComponent(resetSelectedPatientFunction),
                }}
                styles={{
                  container: (provided, state) => ({ ...provided, width: '100%' }),
                  menuList: (provided, state) => ({
                    ...provided,
                    maxHeight: '400px', // Set the desired height here
                    overflowY: 'scroll',
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    display: 'none', // Hides the dropdown arrow
                  }),
                  indicatorSeparator: (provided) => ({
                    ...provided,
                    display: 'none', // Optionally hides the separator line
                  }),
                }}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => getLabelForAlreadyPatientOption(option)}
                // onChange={selectPatientFunction}
                onChange={(patient) => {
                  setSelectedPatient(patient)
                }}
                debounceTimeout={200}
                additional={{
                  page: 1,
                  clinicId,
                  clinicBrandId,
                  mentorAuthorisedToSaveAndGetPatientsUsingIdb: getAllRolesInBoolean().isDoctor,
                  ...(searchPatientApiSignature
                    ? { patientSearchApiSignature: searchPatientApiSignature }
                    : {}),
                }}
              /> */}
            </PatientsSelectHeaderContainer>
            <Button
              size="small"
              sx={{
                flexDirection: 'column',
                alignItems: 'center',
                '.MuiButton-startIcon': {
                  marginRight: 0,
                  marginLeft: 0,
                },
              }}
              variant="contained"
              color="emrSecondary"
              onClick={() => {
                setSelectedPatient(null)
                setShowNewPatientForm(true)
              }}
              startIcon={<PersonAddIcon />}
            >
              Add
            </Button>
          </div>
        ) : (
          <NewPatientForm
            clinicBrandId={clinicBrandId}
            clinicId={clinicId}
            mentorProfileData={mentorProfileData}
            afterAddPatientFunction={(patInfo) => {
              setSelectedPatient(patInfo)
              setShowNewPatientForm(false)
            }}
            closeDialog={() => {
              setShowNewPatientForm(false)
            }}
            setSelectedPatient={setSelectedPatient}
            createPatientApiSignature={createPatientApiSignature}
          />
        )}
      </div>
    </NewBookingPopup>
  )
}

export default function NewBookingPopup({
  selectedPatient,
  refreshData,
  mentorsList,
  appointmentTypesList,
  mentorProfileData,
  closeDialog,
  defaultTab = MENTOR_NEW_BOOKING_TABS?.patientReports?.id,
  selectedSlotData,
  children,
  filterOutTabs = [],
  oldBookingDialogComponentRenderer,
  patientHistoryGetApiSignature,
  hideSendToDoctorButton = false,
}) {
  const [currentTab, setCurrentTab] = useState(defaultTab)
  const tabsToShow = useMemo(() => {
    if (!selectedPatient) {
      return MENTOR_NEW_BOOKING_TABS_LIST?.filter((tab) => {
        return tab?.id === MENTOR_NEW_BOOKING_TABS?.appointment?.id
      })
    }
    return MENTOR_NEW_BOOKING_TABS_LIST?.filter((tab) => {
      if (filterOutTabs?.includes(tab?.id)) {
        return false
      }
      if (tab?.id === MENTOR_NEW_BOOKING_TABS?.old_appointment?.id) {
        return !!oldBookingDialogComponentRenderer
      }
      return true
    })
  }, [selectedPatient, filterOutTabs, oldBookingDialogComponentRenderer])

  function checkIfTabIsVisible(tabId) {
    return tabsToShow?.some((tab) => tab?.id === tabId)
  }

  return (
    <>
      <DialogTitle
        sx={{
          backgroundColor: MUIThemeConfig.palette.emrPrimary.main,
          color: 'white',
        }}
      >
        <div className="d-flex align-items-center justify-content-between">
          {selectedPatient ? (
            <div className="d-flex align-items-center gap-2">
              <Avatar src={selectedPatient?.profilePicture} />
              <div className="d-flex flex-column">
                <div>{selectedPatient?.name}</div>
                <div className="d-flex align-items-center gap-2">
                  {selectedPatient?.gender} | {getAgeFromDobWithTime(selectedPatient?.dateOfBirth)}{' '}
                  Years | {selectedPatient?.patientNumber}
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex align-items-center gap-2">
              <div>Select/Add Patient</div>
            </div>
          )}
          <div className="d-flex align-items-center justify-content-end gap-2">
            <BaseUITabsComponent
              value={currentTab}
              onChange={(e) => {
                setCurrentTab(e)
              }}
              containerStyle={{ marginLeft: '10px' }}
              containerClassName="fs-6 gap-1"
              textWhiteAlways
              tabs={tabsToShow}
              getTabId={(tab) => tab?.id}
              getTabLabel={(tab) => tab?.title}
              alignContentInColumnForm
              incicatorColor="emrSecondary"
            />
            <IconButton onClick={closeDialog} sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </DialogTitle>
      <DialogContent pt={0}>
        {children}
        {currentTab === MENTOR_NEW_BOOKING_TABS?.old_appointment?.id &&
          checkIfTabIsVisible(MENTOR_NEW_BOOKING_TABS?.old_appointment?.id) &&
          oldBookingDialogComponentRenderer({
            isInDialog: true,
            selectedPatient,
          })}
        {currentTab === MENTOR_NEW_BOOKING_TABS?.appointment?.id &&
          checkIfTabIsVisible(MENTOR_NEW_BOOKING_TABS?.appointment?.id) && (
            <CreateBookingTab
              selectedPatient={selectedPatient}
              refreshData={refreshData}
              manuallySelectSlotTiming={!selectedSlotData}
              selectedSlotData={selectedSlotData}
              mentorsList={mentorsList}
              appointmentTypesList={appointmentTypesList}
              closeDialog={closeDialog}
              mentorProfileData={mentorProfileData}
            />
          )}
        {currentTab === MENTOR_NEW_BOOKING_TABS?.patientReports?.id &&
          selectedPatient &&
          checkIfTabIsVisible(MENTOR_NEW_BOOKING_TABS?.patientReports?.id) && (
            <PastPatientReportsDialog
              closeDialog={closeDialog}
              patientInfo={selectedPatient}
              patientHistoryGetApiSignature={patientHistoryGetApiSignature}
            />
          )}
        {currentTab === MENTOR_NEW_BOOKING_TABS?.patientHistory?.id &&
          selectedPatient &&
          checkIfTabIsVisible(MENTOR_NEW_BOOKING_TABS?.patientHistory?.id) && (
            <PastPatientReportsDialog
              closeDialog={closeDialog}
              patientInfo={selectedPatient}
              hideSendToDoctorButton={hideSendToDoctorButton}
              forceShowAllReports
              patientHistoryGetApiSignature={patientHistoryGetApiSignature}
            />
          )}
        {!checkIfTabIsVisible(currentTab) && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: '400px' }}
          >
            <h4 style={{ color: 'rgba(0, 0, 0, 0.5)' }}>Please select a tab from above</h4>
          </div>
        )}
      </DialogContent>
    </>
  )
}
